var getUrl = function(controller, action) {
    if (action) {
        return "/" + controller + "/" + action;
    } else {
        return "/" + controller;
    }
};

var postOptionsUrl = function(url, data) {
    return {
        url: url,
        data: JSON.stringify(data),
        method: "POST",
        headers: {
            "Content-Type": "application/json; text/html; charset=utf-8"
        },
        contentType: "application/json; text/html; charset=utf-8"
    };
};

var postOptions = function(controller, action, data) {
    var url = getUrl(controller, action);
    return postOptionsUrl(url, data);
};

$(function() {
    var $container = $('.blog-listing-wrap');
    var $categoryFilter = $('#filterByCategory');
    var $authorFilter = $('#filterByAuthor');

    $(".js-blogListingFilterSubmit").click(function() {
        var selectedCategory = $categoryFilter.val();
        var selectedAuthor = $authorFilter.val();

        var data = {
            category: selectedCategory,
            author: selectedAuthor
        };

        $.ajax(postOptions("BlogListingBlock", "BlogPostListing", data))
            .then(function(response) {
                $container.html(response);
            })
    });
})
